import { render, staticRenderFns } from "./MissingVATNumbers.vue?vue&type=template&id=08e6418e"
import script from "./MissingVATNumbers.vue?vue&type=script&lang=ts"
export * from "./MissingVATNumbers.vue?vue&type=script&lang=ts"
import style0 from "./MissingVATNumbers.vue?vue&type=style&index=0&id=08e6418e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports